import Default from '../../images/map-layers/default.png';
import Satellite from '../../images/map-layers/satellite.png';

export default [
  {
    id: 'default',
    label: 'Default',
    source: 'https://api.os.uk/maps/vector/v1/vts/resources/styles',
    image: Default,
  },
  {
    id: 'satellite',
    label: 'Satellite',
    source: 'mapbox://styles/mapbox/satellite-v9',
    image: Satellite,
  },
];
